import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import MenuIcon from 'material-ui-icons/Menu';
import Typography from 'material-ui/Typography';
import LoginIcon from 'material-ui-icons/AccountCircle';
import classnames from 'classnames'

import AppMenu from './StackupDesign/AppMenu';
import { APP_DRAWER_WIDTH } from '../constants/globals';

const styles= theme => ({
  grow: {
    flex: '1 1 auto',
  },
  title: {
    marginLeft: 24,
    flex: '0 1 auto',
  },
  appBar: {
    transition: theme.transitions.create('width'),
  },
  appBarHome: {
    boxShadow: 'none',
    backgroundColor: 
      theme.palette.type === 'light' ? theme.palette.primary.light : theme.palette.primary.dark,
    color: theme.palette.primary.contrastText,
  },
  [theme.breakpoints.up('lg')]: {
    appBarShift: {
      width: `calc(100% - ${APP_DRAWER_WIDTH}px)`,
    },
    navIconHide: {
      display: 'none',
    },
  },
  '@media print': {
    loginIcon: {
      display: 'none'
    }
  }
});

export const AppHead = ({
  classes,
  handleDrawerToggle,
  handleLogin,
  title,
  showAppMenu
}) => {
    let navIconClassName = '';
    let appBarClassName;

    if (title === '') {
       // home route, don't shift app bar or dock drawer
      appBarClassName = classnames(classes.appBar, classes.appBarHome);

    } else {
      navIconClassName += classes.navIconHide;
      appBarClassName = classnames(classes.appBar, classes.appBarShift);
    }

    return (
      <AppBar className={appBarClassName}>
        <Toolbar>
          <IconButton
            data-test="drawer-toggle"
            color="inherit"
            onClick={handleDrawerToggle}
            className={navIconClassName}
          >
            <MenuIcon />
          </IconButton>
          {title !== null && (
            <Typography
              className={classes.title}
              variant="title"
              color="inherit"
              noWrap
            >
              { title }
            </Typography>
          )}
          <div className={classes.grow} />
          {showAppMenu ? <AppMenu /> : null}
          <IconButton
            className={classes.loginIcon}
            disabled
            data-test="login"
            title="Login"
            color="inherit"
            onClick={handleLogin}
          >
            <LoginIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
    );
}

AppHead.propTypes = {
  classes:            PropTypes.shape({
    appBar: PropTypes.string, 
    appBarHome: PropTypes.string, 
    appBarShift: PropTypes.string, 
    grow: PropTypes.string, 
    navIconHide: PropTypes.string, 
    title: PropTypes.string
  }).isRequired,
  title:              PropTypes.string,
  handleDrawerToggle: PropTypes.func.isRequired,
  handleLogin:        PropTypes.func.isRequired,
  showAppMenu: PropTypes.bool,
};

AppHead.defaultProps = {
  title: '',
  showAppMenu: false
}

export default withStyles(styles)(AppHead);



// WEBPACK FOOTER //
// ./src/components/AppHead.js